import { SOURCE_STATUSES } from "react-migration/domains/constraints/constants";

interface SourceStatusProps {
  status?: string;
}

export function SourceStatus({ status }: SourceStatusProps) {
  const sourceStatus = SOURCE_STATUSES.find((x) => x.id === status);
  if (!sourceStatus || status === "adopted") return null;

  return (
    <div className="rounded-full bg-amber-500 p-1 px-2 text-white text-3xs font-normal">
      {sourceStatus.display_name}
    </div>
  );
}
